import { render } from "./SparePart.vue?vue&type=template&id=43d2c953&scoped=true&bindings={}"
import script from "./SparePart.vue?vue&type=script&lang=ts"
export * from "./SparePart.vue?vue&type=script&lang=ts"

import "./SparePart.vue?vue&type=style&index=0&id=43d2c953&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43d2c953"

export default script